import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { LOGIN_PATH_NAME } from '@kfc-global/react-shared/config/config.constants';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { ROUTE_URL, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import events from '@kfc-global/react-shared/analytics/Register';
import { getDataLayer, isSupportedTenantCode } from 'common/utilities/utils';
import { logEvent } from 'common/utilities/analyticsUtils';

const { getInstance: auth } = AuthManager;

export const getPathName = () => {
  const { HOME_PAGE, SIGNOUT } = ROUTE_URL;
  const pathName = window.location.pathname;
  if (pathName === SIGNOUT) {
    return HOME_PAGE;
  }
  return pathName;
};

export const login = () => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.LOCALIZATION_SIGN_IN, JSON.stringify(true));
  const redirectUri = window.location.origin + config(LOGIN_PATH_NAME);
  const signInUrl = auth().generateSignInUrl(redirectUri, false, getPathName());
  logEvent(events.signInStart?.name, {
    '%event%': 'signInStart',
    '%platform%': 'web',
  });
  window.location.assign(signInUrl);
};

// Uncomment #27 post implementation
// istanbul ignore next
export const createAccount = customerDetails => {
  const redirectUri = window.location.origin + config(LOGIN_PATH_NAME);
  const isSignUpUrl = isSupportedTenantCode();
  let signUpUrl = auth().generateSignInUrl(redirectUri, isSignUpUrl, getPathName());
  if (customerDetails) {
    signUpUrl = `${signUpUrl}&${customerDetails}`;
  }
  window.location.assign(signUpUrl);
};

export const setAnalyticsRegistrationFinish = (isNewCustomer, loginMethod = 'email') => {
  const {
    phoneNumber,
    customerId,
    firstName,
    familyName: lastName,
    email,
    emailSubscription,
    phoneSubscription,
    postal_code,
    customerInfoRequestPayload,
  } = auth();
  if (customerId && isNewCustomer) {
    logEvent(
      events.registrationFinish?.name,
      {
        '%event%': 'registrationFinish',
        '%loginMethod%': loginMethod || 'NA',
        '%userID%': customerId,
        '%firstName%': firstName || 'NA',
        '%lastName%': lastName || 'NA',
        '%emailAddress%': email || 'NA',
        '%phoneNumber%': phoneNumber || 'NA',
        '%postCode%': postal_code || 'NA',
        '%marketingEmails%': emailSubscription ? 'true' : 'false',
        '%accept_terms_and_conditions%': 'true',
        '%receiveSMS%':
          customerInfoRequestPayload?.payload?.phoneSubscription === undefined ? 'NA' : '' + phoneSubscription,
      },
      getDataLayer,
    );
  }
};

export const setAnalyticsSignInSkipped = () => {
  const { customerId } = auth();
  logEvent(
    events.signInFinish?.name,
    {
      '%event%': 'signInFinish',
      '%userID%': customerId || 'NA',
      '%loginMethod%': 'I’m a guest, sign me up later!',
      '%firstName%': 'NA',
      '%lastName%': 'NA',
      '%phoneNumber%': 'NA',
    },
    getDataLayer,
  );
};

export const setAnalyticsSignInFinish = () => {
  const { phoneNumber, customerId, firstName, familyName: lastName, email, loginMethod, postal_code } = auth();
  logEvent(
    events.signInFinish?.name,
    {
      '%event%': 'signInFinish',
      '%userID%': customerId || 'NA',
      '%loginMethod%': loginMethod || 'NA',
      '%firstName%': firstName || 'NA',
      '%lastName%': lastName || 'NA',
      '%phoneNumber%': phoneNumber || 'NA',
      '%emailAddress%': email || 'NA',
      '%postCode%': postal_code || 'NA',
    },
    getDataLayer,
  );
};

export const getCardDateFormat = cardDate => {
  const date = new Date(cardDate);

  if (isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 because months are zero-based
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}/${month}/${day}`;
};
